var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { Box, makeStyles, Typography } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import LanguageIcon from '@material-ui/icons/Language';
import { TrackableEvents } from '../../shared';
import { useEventTracker } from '../../shared/hooks';
import { LanguageSelectionVariants, MenuPositions } from './enums';
import { LanguageMenu } from './LanguageMenu';
import { UpdateUserLanguagePreferenceMutation, } from '../../schema/user/client/mutations';
import { eventBus } from '../../shared/helpers';
import { useAuthentication, useCookies, useFeature, useViewerContext } from '../../shared/hooks';
import { BrandColors, DefaultTheme } from '../../themes/DefaultTheme';
var spacing = DefaultTheme.spacing;
export var COOKIE_PREF_KEY = 'accept_language';
export var DEFAULT_LANGUAGE = 'en';
export var FF_LANG_SEL = 'pl_i18n_web';
export var FF_LANG_DEV = 'intl_lang_sel_dev';
export var SAVE_LANGUAGE_EVENT_NAME = 'saveLanguage';
export var TEST_COMPONENT_ID = 'intl_lang_sel_component';
export var TEST_ICON_ID = 'intl_lang_sel_icon';
export var TEST_LABEL_ID = 'intl_lang_sel_label';
export var TEST_DOWN_ARROW_ID = 'intl_lang_sel_down';
export var SCHEMA_CLICKED_LANGUAGE_SELECTOR = 'users/clicked-languageselector.v1.0.0.schema.json';
export var SCHEMA_SELECTED_LANGUAGE_IN_LANGUAGE_SELECTOR = 'users/selected-language-in-languageselector.v1.0.0.schema.json';
var componentConfig = new Map([
    [
        LanguageSelectionVariants.LIGHT,
        {
            style: {
                border: BrandColors.CONCRETE,
                border_active: BrandColors.VIOLET,
                color: BrandColors.NAVY,
                maxWidth: '100%',
                menu_item_radius: spacing(0.5),
                menu_padding: spacing(2),
                width: "min(" + spacing(45) + "px, 100%)",
            },
        },
    ],
    [
        LanguageSelectionVariants.DARK,
        {
            style: {
                border_active: BrandColors.WANDERGREEN,
                icon_active: BrandColors.WANDERGREEN,
                color: BrandColors.WHITE,
            },
        },
    ],
    [
        LanguageSelectionVariants.NORMAL,
        {
            style: {
                border: BrandColors.NAVY,
                width: 'auto',
            },
        },
    ],
]);
var useStyles = makeStyles(function (_a) {
    var spacing = _a.spacing;
    return ({
        root: function (_a) {
            var border = _a.border, border_active = _a.border_active, color = _a.color, is_active = _a.is_active, minWidth = _a.minWidth, maxWidth = _a.maxWidth, width = _a.width;
            var borderColor = is_active && border_active ? border_active : border || color;
            return {
                alignItems: 'center',
                backgroundColor: 'transparent',
                borderRadius: spacing(0.5),
                borderColor: borderColor,
                borderStyle: 'solid',
                borderWidth: 1,
                boxSizing: 'border-box',
                color: color,
                cursor: 'pointer',
                display: 'inline-flex',
                flexDirection: 'row',
                maxWidth: maxWidth,
                minWidth: minWidth || spacing(21),
                padding: spacing(1, 2),
                position: 'relative',
                width: width,
            };
        },
        label: {
            marginLeft: spacing(1),
        },
        icon: function (_a) {
            var color = _a.color, icon_active = _a.icon_active, is_active = _a.is_active;
            var icon_color = is_active && icon_active ? icon_active : color;
            return {
                color: icon_color,
                cursor: 'pointer',
            };
        },
        dropDown: {
            marginLeft: 'auto',
        },
    });
});
export var languageLabel = function (lang) {
    var label = (supportedLanguages.get(lang) || supportedLanguages.get(DEFAULT_LANGUAGE)).label;
    return label;
};
export var supportedLanguages = new Map([
    ['de', { label: 'Deutsch' }],
    ['en', { label: 'English' }],
    ['es', { label: 'Español' }],
    ['fr', { label: 'Français' }],
    ['pt', { label: 'Português' }],
    ['en-XA', { label: 'XA', dev: true }],
    ['en-XB', { label: 'XB', dev: true }],
]);
export var LanguageSelection = function (_a) {
    var className = _a.className, icon = _a.icon, label = _a.label, onLanguageChange = _a.onLanguageChange, padMenu = _a.padMenu, _b = _a.position, position = _b === void 0 ? MenuPositions.BOTTOM : _b, _c = _a.saveOnChange, saveOnChange = _c === void 0 ? true : _c, select = _a.select, _d = _a.variant, variant = _d === void 0 ? LanguageSelectionVariants.NORMAL : _d, width = _a.width;
    var showComponent = useFeature(FF_LANG_SEL).treatment === 'on';
    var showDeveloperLangs = useFeature(FF_LANG_DEV).treatment === 'on';
    var _e = __read(useMutation(UpdateUserLanguagePreferenceMutation), 1), updateUserLanguagePreferenceMutation = _e[0];
    var isAuthenticated = useAuthentication().isAuthenticated;
    var _f = useCookies(), getCookie = _f.getCookie, setCookie = _f.setCookie;
    var user_lang = matchLanguage(getCookie(COOKIE_PREF_KEY));
    var _g = __read(useState(null), 2), anchorEl = _g[0], setAnchorEl = _g[1];
    var _h = __read(useState(user_lang), 2), language = _h[0], setLanguage = _h[1];
    var _j = __read(useState('auto'), 2), menuWidth = _j[0], setMenuWidth = _j[1];
    var open = Boolean(anchorEl);
    var trackEvent = useEventTracker().trackEvent;
    var style = componentConfig.get(variant).style;
    var classes = useStyles(__assign(__assign({}, style), { is_active: open, width: width }));
    var user = useViewerContext().user;
    function availableLanguages() {
        var e_1, _a;
        var langs = new Map([]);
        try {
            for (var supportedLanguages_1 = __values(supportedLanguages), supportedLanguages_1_1 = supportedLanguages_1.next(); !supportedLanguages_1_1.done; supportedLanguages_1_1 = supportedLanguages_1.next()) {
                var _b = __read(supportedLanguages_1_1.value, 2), key = _b[0], value = _b[1];
                if (showDeveloperLangs || (!showDeveloperLangs && !value.dev)) {
                    langs.set(key, languageLabel(key));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (supportedLanguages_1_1 && !supportedLanguages_1_1.done && (_a = supportedLanguages_1.return)) _a.call(supportedLanguages_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return langs;
    }
    function handleOpen(event) {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        setMenuWidth(event.currentTarget.clientWidth);
        trackEvent(TrackableEvents.ClickedLanguageSelector, {
            schema: SCHEMA_CLICKED_LANGUAGE_SELECTOR,
            user_id: user === null || user === void 0 ? void 0 : user.id,
        });
    }
    function handleClose(event) {
        if (event) {
            event.stopPropagation();
            if (typeof event.target === 'object' && event.target.hasAttribute('value')) {
                var prev_language = language;
                var selected_language = event.target.getAttribute('value');
                trackEvent(TrackableEvents.SelectedLanguageInLanuageSelector, {
                    schema: SCHEMA_SELECTED_LANGUAGE_IN_LANGUAGE_SELECTOR,
                    user_id: user === null || user === void 0 ? void 0 : user.id,
                    prev_language: prev_language,
                    selected_language: selected_language,
                });
                setUserLanguage(selected_language);
            }
        }
        setAnchorEl(null);
    }
    function matchLanguage(languageToken) {
        if (!languageToken) {
            return DEFAULT_LANGUAGE;
        }
        var languages = availableLanguages();
        if (languages.has(languageToken)) {
            return languageToken;
        }
        var keys = Array.from(languages.keys());
        var _a = __read(languageToken.split(/[-_]/), 1), base = _a[0];
        if (keys.includes(base)) {
            return base;
        }
        return DEFAULT_LANGUAGE;
    }
    function reload() {
        if (window) {
            window.document.location.reload();
        }
    }
    function setLanguageAndReload(lang) {
        return __awaiter(this, void 0, void 0, function () {
            var input;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setCookie({ key: COOKIE_PREF_KEY, value: lang });
                        if (!isAuthenticated) return [3, 2];
                        input = { languageTag: lang };
                        return [4, updateUserLanguagePreferenceMutation({ variables: { input: input } })];
                    case 1:
                        _a.sent();
                        reload();
                        return [3, 3];
                    case 2:
                        reload();
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        });
    }
    function setUserLanguage(lang) {
        if (language !== lang) {
            setLanguage(lang);
            if (onLanguageChange) {
                onLanguageChange(lang);
            }
            else {
                setLanguageAndReload(lang);
            }
        }
    }
    useEffect(function () {
        if (saveOnChange === false) {
            var callback = function (detail) {
                setLanguageAndReload(detail.lang);
            };
            eventBus.on(SAVE_LANGUAGE_EVENT_NAME, callback);
            return function () {
                eventBus.remove(SAVE_LANGUAGE_EVENT_NAME);
            };
        }
    }, []);
    if (!showComponent) {
        return null;
    }
    return (React.createElement(Box, { "aria-controls": open ? 'user-language-menu' : undefined, "aria-expanded": open ? 'true' : undefined, "aria-haspopup": "true", className: (select ? classes.root : classes.icon) + " " + className, "data-testid": TEST_COMPONENT_ID, id: "user-language-menu-trigger", onClick: handleOpen, role: "button" },
        icon && React.createElement(LanguageIcon, { className: classes.icon, "data-testid": TEST_ICON_ID }),
        label && (React.createElement(Typography, { className: classes.label, "data-testid": TEST_LABEL_ID, variant: "h5" }, languageLabel(language))),
        select && (React.createElement(Box, { className: classes.dropDown },
            React.createElement(KeyboardArrowDownIcon, { "data-testid": TEST_DOWN_ARROW_ID }))),
        React.createElement(LanguageMenu, { anchor: anchorEl, availableLanguages: availableLanguages(), curLang: language, handleClose: handleClose, minWidth: style.minWidth, open: open, padMenu: padMenu, position: position, width: menuWidth })));
};
//# sourceMappingURL=LanguageSelection.js.map